<app-layout>
  <div class="main dashboard-main patio-dashboard">
    <div class="header-table">
      <div class="header-title-block">
        <app-titulo>{{ dashboardTitle }}</app-titulo>
        <p class="prototype-banner" *ngIf="prototypeBanner">{{ prototypeBanner }}</p>
      </div>
      <div class="header-buttons">
        <app-botao
          type="secundario"
          class="button"
          text="Gerar PDF"
          icon="assets/download.svg"
          [disabled]="isExportingPdf"
          (click)="gerarPDF()"></app-botao>
      </div>
    </div>

    <div #dashboardPdfContent class="dashboard-pdf-content" [class.exporting-pdf]="isExportingPdf">
      <div class="pdf-report-meta">
        <p class="pdf-report-title">{{ dashboardTitle }}</p>
        <p class="pdf-report-period" *ngIf="form.controls['DT_REF'].value">
          Data de referência: {{ formatFilterDate(form.controls['DT_REF'].value) }}
        </p>
        <p class="pdf-report-generated" *ngIf="pdfGeneratedAt">
          Gerado em {{ pdfGeneratedAt | date: 'dd/MM/yyyy HH:mm' }}
        </p>
      </div>

      <div class="filters-card patio-filters">
        <form [formGroup]="form" class="table-filters">
          <app-input
            type="select"
            label="Terminal"
            name="FK_DTNR"
            formControlName="FK_DTNR"
            [selectData]="terminais"
            width="100%"></app-input>
          <app-input
            type="date"
            label="Data de referência"
            placeholder="Digite aqui"
            name="DT_REF"
            formControlName="DT_REF"
            width="100%"></app-input>
          <app-input
            type="select"
            label="Produto"
            name="FK_CRGA"
            formControlName="FK_CRGA"
            [selectData]="produtos"
            width="100%"></app-input>
          <app-input
            type="text"
            label="Placa"
            placeholder="Buscar placa"
            name="TX_PLCA"
            formControlName="TX_PLCA"
            width="100%"></app-input>
        </form>
      </div>

      <section class="dashboard-section" *ngIf="temResumoPatio()">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('summary')">
          <span>Resumo do pátio</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('summary')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('summary')">
      <div class="patio-summary-row">
        <section class="patio-panel patio-panel-total" *ngIf="podeVerGrafico('graficoPatioTotalVeiculos')">
          <h3>Total de veículos</h3>
          <p class="panel-subtitle">Visão consolidada do pátio</p>

          <div class="total-veiculos-hero">
            <div class="hero-highlight">
              <span class="hero-value">{{ formatNumber(totalVeiculosValor('no-patio')) }}</span>
              <span class="hero-label">veículos no pátio</span>
            </div>
            <div class="hero-metrics">
              <div class="hero-metric">
                <span class="hero-metric-value">{{ ocupacaoPercent() }}%</span>
                <span class="hero-metric-label">ocupação</span>
              </div>
              <div class="hero-metric">
                <span class="hero-metric-value">{{ formatNumber(totalVeiculosValor('disponiveis')) }}</span>
                <span class="hero-metric-label">vagas livres</span>
              </div>
            </div>
          </div>

          <div class="total-veiculos-progress" aria-hidden="true">
            <div
              class="progress-segment no-patio"
              [style.flex]="totalVeiculosValor('no-patio') + ' 1 0'"
              [title]="'No pátio: ' + formatNumber(totalVeiculosValor('no-patio'))"></div>
            <div
              class="progress-segment agendados"
              [style.flex]="totalVeiculosValor('agendados') + ' 1 0'"
              [title]="'Agendados: ' + formatNumber(totalVeiculosValor('agendados'))"></div>
            <div
              class="progress-segment disponiveis"
              [style.flex]="totalVeiculosValor('disponiveis') + ' 1 0'"
              [title]="'Disponíveis: ' + formatNumber(totalVeiculosValor('disponiveis'))"></div>
          </div>
          <div class="total-veiculos-legend">
            <span><i class="dot no-patio"></i>No pátio</span>
            <span><i class="dot agendados"></i>Agendados</span>
            <span><i class="dot disponiveis"></i>Disponíveis</span>
          </div>
          <p class="total-veiculos-progress-caption">Distribuição entre veículos no pátio, agendados e vagas livres</p>

          <div class="total-veiculos-grid">
            <div class="total-kpi-card" *ngFor="let item of totalVeiculos" [class]="'tone-' + item.key">
              <span class="total-kpi-label">{{ item.label }}</span>
              <strong class="total-kpi-value">{{ formatNumber(item.value) }}</strong>
              <span class="total-kpi-hint" *ngIf="item.hint">{{ item.hint }}</span>
            </div>
          </div>
        </section>

        <section class="patio-panel" *ngIf="podeVerGrafico('graficoPatioAgendadoTerminais')">
          <h3>AGENDADO POR TERMINAIS</h3>
          <div class="bar-chart horizontal patio-terminal-bars">
            <div class="h-bar-row" *ngFor="let item of agendadoTerminais">
              <span class="h-bar-label">{{ item.label }}</span>
              <div class="h-bar-track">
                <div class="h-bar-fill green" [style.width.%]="barHeight(item.value, agendadoTerminais)"></div>
              </div>
              <span class="h-bar-value patio-value-red">{{ formatNumber(item.value).padStart(3, '0') }}</span>
            </div>
          </div>
        </section>

        <section class="patio-panel" *ngIf="podeVerGrafico('graficoPatioTotalNoPatio')">
          <h3>TOTAL NO PÁTIO</h3>
          <div class="bar-chart horizontal patio-terminal-bars">
            <div class="h-bar-row" *ngFor="let item of noPatioTerminais">
              <span class="h-bar-label">{{ item.label }}</span>
              <div class="h-bar-track">
                <div class="h-bar-fill green" [style.width.%]="barHeight(item.value, noPatioTerminais)"></div>
              </div>
              <span class="h-bar-value patio-value-red">{{ formatNumber(item.value).padStart(3, '0') }}</span>
            </div>
          </div>
        </section>

        <section class="patio-panel" *ngIf="podeVerGrafico('graficoPatioTempoPermanencia')">
          <h3>TEMPO DE PERMANÊNCIA</h3>
          <div class="permanencia-bars">
            <div class="permanencia-row" *ngFor="let bucket of permanencia">
              <span class="permanencia-label">{{ bucket.label }}</span>
              <div class="permanencia-track">
                <div
                  class="permanencia-fill"
                  [class]="'tone-' + bucket.tone"
                  [style.width.%]="permanenciaPercent(bucket)"></div>
              </div>
              <span class="permanencia-badge">{{ bucket.value }}</span>
            </div>
          </div>
        </section>
      </div>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="temIndicadoresOperacionais()">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('detail')">
          <span>Indicadores operacionais e agendamentos</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('detail')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('detail')">
      <div class="patio-detail-row">
        <section class="patio-panel" *ngIf="podeVerGrafico('graficoPatioDiarioTotal')">
          <h3>DIÁRIO TOTAL</h3>
          <p class="panel-subtitle">Quilograma(s)/Viagens</p>
          <div class="donut-layout">
            <div class="donut-chart-wrap">
              <div class="donut-chart" [style.background]="pieGradient(diarioTotal.slices)"></div>
              <div class="donut-center">
                <span class="donut-center-label">Total</span>
                <strong>{{ formatKg(diarioTotal.totalKg) }}</strong>
              </div>
            </div>
            <ul class="pie-legend donut-legend">
              <li *ngFor="let slice of diarioTotal.slices">
                <i [style.background]="slice.color"></i>
                <span>{{ slice.label }}</span>
                <strong>{{ formatNumber(slice.value) }}</strong>
              </li>
            </ul>
          </div>
        </section>

        <ng-container
          *ngIf="podeVerGrafico('graficoPatioAgendamentosD')"
          [ngTemplateOutlet]="agendamentoDia"
          [ngTemplateOutletContext]="{ config: agendamentoPainelD, resumo: agendamentosD }">
        </ng-container>

        <ng-container
          *ngIf="podeVerGrafico('graficoPatioAgendamentosD1')"
          [ngTemplateOutlet]="agendamentoDia"
          [ngTemplateOutletContext]="{ config: agendamentoPainelD1, resumo: agendamentosD1 }">
        </ng-container>

        <ng-container
          *ngIf="podeVerGrafico('graficoPatioAgendamentosD2')"
          [ngTemplateOutlet]="agendamentoDia"
          [ngTemplateOutletContext]="{ config: agendamentoPainelD2, resumo: agendamentosD2 }">
        </ng-container>
      </div>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="podeVerGrafico('graficoPatioEstacionamento')">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('estacionamento')">
          <span>Quantidade de Estacionamento</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('estacionamento')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('estacionamento')">
          <div class="estacionamento-receita-banner">
            <span class="estacionamento-receita-label">Receita financeira do pátio (dia)</span>
            <strong class="estacionamento-receita-value">{{ formatCurrency(receitaPatioTotal) }}</strong>
          </div>
          <div class="estacionamento-kpi-grid">
            <div class="estacionamento-kpi-card">
              <span class="estacionamento-kpi-label">Estacionamentos agendados</span>
              <strong class="estacionamento-kpi-value">{{ formatNumber(estacionamentosAgendados) }}</strong>
              <span class="estacionamento-kpi-finance">{{ formatCurrency(valorEstacionamentosAgendados) }}</span>
              <span class="estacionamento-kpi-hint">Com agendamento na janela</span>
            </div>
            <div class="estacionamento-kpi-card">
              <span class="estacionamento-kpi-label">Estacionamentos avulsos</span>
              <strong class="estacionamento-kpi-value">{{ formatNumber(estacionamentosAvulsos) }}</strong>
              <span class="estacionamento-kpi-finance">{{ formatCurrency(valorEstacionamentosAvulsos) }}</span>
              <span class="estacionamento-kpi-hint">Entrada sem agendamento</span>
            </div>
            <div class="estacionamento-kpi-card tone-pre-patio">
              <span class="estacionamento-kpi-label">Estacionamento Pré-pátio</span>
              <strong class="estacionamento-kpi-value">{{ formatNumber(estacionamentosPrePatio) }}</strong>
              <span class="estacionamento-kpi-finance">{{ formatCurrency(valorEstacionamentosPrePatio) }}</span>
              <span class="estacionamento-kpi-hint">Grãos com entrada antes da janela</span>
            </div>
          </div>
        </div>
      </section>

      <section class="dashboard-section" *ngIf="podeVerGrafico('graficoPatioTurnos')">
        <button type="button" class="dashboard-section-toggle" (click)="toggleSection('turnos')">
          <span>Turnos e veículos</span>
          <span class="dashboard-section-chevron" [class.collapsed]="isSectionCollapsed('turnos')"></span>
        </button>
        <div class="dashboard-section-body" [class.collapsed]="isSectionCollapsed('turnos')">
      <div class="patio-turnos-row">
        <section class="patio-panel turno-panel" *ngFor="let turno of turnos">
          <div class="turno-header">
            <h3>{{ turno.horario }}</h3>
            <p class="turno-capacity">
              VEÍCULOS: <strong>{{ formatNumber(turnoVeiculosCount(turno)) }}</strong> de
              <strong>{{ formatNumber(turno.capacidade) }}</strong>
            </p>
          </div>
          <div class="turno-progress-track">
            <div class="turno-progress-fill" [style.width.%]="turnoProgress(turno)"></div>
          </div>
          <div class="turno-veiculos">
            <div
              class="veiculo-card"
              *ngFor="let veiculo of turno.veiculos"
              [class.empty]="veiculo.status === 'vazio'"
              [class.clickable]="veiculo.status !== 'vazio'"
              [class.status-em-andamento]="veiculo.status === 'em-andamento'"
              [class.status-atrasado]="veiculo.status === 'atrasado'"
              [class.status-finalizado]="veiculo.status === 'finalizado'"
              [class.status-previsto]="veiculo.status === 'previsto'"
              (click)="navegarVeiculo(veiculo)"
              (keyup.enter)="navegarVeiculo(veiculo)"
              [attr.tabindex]="veiculo.status !== 'vazio' ? 0 : null"
              [attr.role]="veiculo.status !== 'vazio' ? 'button' : null">
              <ng-container *ngIf="veiculo.status !== 'vazio'; else slotVazio">
                <div class="veiculo-info">
                  <span class="veiculo-text">{{ veiculo.placa }} - {{ veiculo.motorista }}</span>
                </div>
              </ng-container>
              <ng-template #slotVazio>
                <span class="veiculo-vazio">—</span>
              </ng-template>
            </div>
          </div>
        </section>
      </div>
        </div>
      </section>
    </div>
  </div>

  <app-loader [isLoading]="isLoading || isExportingPdf"></app-loader>
</app-layout>

<ng-template #agendamentoDia let-config="config" let-resumo="resumo">
  <section class="patio-panel patio-panel-agendamento" [class]="'theme-' + config.theme">
    <div class="agendamento-panel-header">
      <div>
        <h3>{{ config.titulo }}</h3>
        <p class="panel-subtitle">{{ config.subtitulo }}</p>
      </div>
      <span class="agendamento-badge">{{ config.badge }}</span>
    </div>

    <div class="agendamento-hero">
      <div class="hero-highlight">
        <span class="hero-value">{{ formatNumber(resumo.agendados) }}</span>
        <span class="hero-label">agendamentos confirmados</span>
      </div>
      <div class="hero-metrics">
        <div class="hero-metric">
          <span class="hero-metric-value">{{ agendamentoOcupacao(resumo) }}%</span>
          <span class="hero-metric-label">vagas ocupadas</span>
        </div>
        <div class="hero-metric">
          <span class="hero-metric-value">{{ formatNumber(resumo.noPatio) }}</span>
          <span class="hero-metric-label">já no pátio</span>
        </div>
      </div>
    </div>

    <div class="agendamento-progress" aria-hidden="true">
      <div
        class="progress-segment no-patio"
        [style.flex]="agendamentoNoPatioNaJanela(resumo) + ' 1 0'"
        [title]="'No pátio: ' + formatNumber(agendamentoNoPatioNaJanela(resumo))"></div>
      <div
        class="progress-segment pre-patio"
        [style.flex]="resumo.prePatio + ' 1 0'"
        [title]="'Pré-pátio: ' + formatNumber(resumo.prePatio)"></div>
      <div
        class="progress-segment aguardando"
        [style.flex]="agendamentoAguardando(resumo) + ' 1 0'"
        [title]="'Aguardando chegada: ' + formatNumber(agendamentoAguardando(resumo))"></div>
      <div
        class="progress-segment cancelados"
        [style.flex]="resumo.cancelados + ' 1 0'"
        [title]="'Cancelados: ' + formatNumber(resumo.cancelados)"></div>
      <div
        class="progress-segment vagas-livres"
        [style.flex]="agendamentoVagasLivres(resumo) + ' 1 0'"
        [title]="'Vagas livres: ' + formatNumber(agendamentoVagasLivres(resumo))"></div>
    </div>
    <div class="agendamento-legend">
      <span><i class="dot no-patio"></i>No pátio</span>
      <span><i class="dot pre-patio"></i>Pré-pátio</span>
      <span><i class="dot aguardando"></i>Aguardando</span>
      <span><i class="dot cancelados"></i>Cancelados</span>
      <span><i class="dot vagas-livres"></i>Vagas livres</span>
    </div>
    <p class="agendamento-progress-caption">Distribuição das vagas e status dos agendamentos</p>

    <div class="agendamento-cards">
      <div class="agendamento-card" *ngFor="let item of agendamentoItens(resumo)" [class]="'tone-' + item.key">
        <span class="agendamento-card-label">{{ item.label }}</span>
        <strong class="agendamento-card-value">{{ formatNumber(item.value) }}</strong>
        <span class="agendamento-card-hint" *ngIf="item.hint">{{ item.hint }}</span>
      </div>
    </div>
  </section>
</ng-template>
